import { formatPercentage } from '@roc/ui/utils';
import { observer } from 'mobx-react';
import { LoanDetailsCard } from './loanDetailsCard';
import { LoanDetailsCardProps } from './summaryStep';

export const FixFlipLoanDetailsCard = observer(
  ({ store }: LoanDetailsCardProps) => {
    return <_FixFlipLoanDetailsCard store={store} showAccordion={true} />;
  }
);
export const FixFlipLoanDetailsCardNoAccordion = observer(
  ({ store }: LoanDetailsCardProps) => {
    return <_FixFlipLoanDetailsCard store={store} showAccordion={false} />;
  }
);

const _FixFlipLoanDetailsCard = observer(
  ({
    store,
    showAccordion,
  }: LoanDetailsCardProps & { showAccordion: boolean }) => {
    const calculatedFields = store.loanEconomicsStore.calculateFields();

    const ltcPurchasePricePercentage = formatPercentage(
      calculatedFields.loanToCost
    );
    const ltcConstructionBudgetHoldbackPercentage = formatPercentage(
      calculatedFields.constructionReserve
    );
    const ARLTV = formatPercentage(calculatedFields.afterRepairLTV);

    return (
      <LoanDetailsCard
        store={store}
        keyRatios={`${ltcPurchasePricePercentage} / ${ltcConstructionBudgetHoldbackPercentage} / ${ARLTV}`}
        showAccordion={showAccordion}
        keyRatiosTooltip={
          'LTC Purchase Price / LTC Construction Budget (Holdback) / ARLTV'
        }
      />
    );
  }
);
